import axios from 'axios';
import { forEachObjIndexed } from 'ramda';

import layoutActions from '../redux/layout';
import { isNilOrEmpty } from './redux';

export const putFiles = (url, payload, options) =>
  axios.post(url, toLaravelFormData(payload, 'PUT'), { ...filesOptions, ...options });
export const patchFiles = (url, payload, options) =>
  axios.post(url, toLaravelFormData(payload, 'PATCH'), { ...filesOptions, ...options });
export const postFiles = (url, payload, options) =>
  axios.post(url, toLaravelFormData(payload, 'POST'), { ...filesOptions, ...options });

export default () => {
  window.axios = axios;
  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  // Globally register csrf token
  let token = document.head.querySelector('meta[name="csrf-token"]');
  if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  } else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
  }

  // Add interceptors for loaders
  window.axios.interceptors.request.use((config) => {
    if (!config.skipLoader) {
      window.globalDispatch(layoutActions.showLoader());
    }
    return config;
  });
  window.axios.interceptors.response.use(
    (response) => {
      window.globalDispatch(layoutActions.hideLoader());
      return response;
    },
    (error) => {
      window.globalDispatch(layoutActions.hideLoader());
      return Promise.reject(error);
    },
  );
};

/**
 * Helpers
 */
const filesOptions = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const toLaravelFormData = (payload, method) => {
  const formData = objectToFormData(payload);
  formData.append('_method', method);
  return formData;
};

// Recursively add form data
const objectToFormData = (payload, form, namespace) => {
  const formData = form || new FormData();
  let formKey;

  forEachObjIndexed((value, key) => {
    formKey = namespace ? `${namespace}[${key}]` : key;

    if (typeof value === 'object' && !(value instanceof File)) {
      objectToFormData(value, formData, key);
    } else if (!isNilOrEmpty(value)) {
      formData.append(formKey, value);
    }
  }, payload);

  return formData;
};
